<div class="ni-history">
  <p class="ni-msg" *ngIf="visible.length === 0">
    No history yet. Items you open will show up here.
  </p>
  <ul class="ni-history-list">
    <li *ngFor="let h of visible">
      <span class="ni-hist-time">{{ h.viewedAt | date:'short' }}</span>
      <a class="ni-hist-link" [href]="h.link" target="_blank" rel="noopener">{{ h.title }}</a>
      <span class="ni-hist-src">{{ h.source }}</span>
    </li>
  </ul>
</div>
